import React, { ReactNode, useEffect, useState } from 'react';
import { Radio, Label } from "flowbite-react";
import { useAuth } from '../../hooks/useAuth';
import { useLoader } from "../../hooks/useLoader";
import { useNavigate } from 'react-router-dom';

import ApiService from '../../services/ApiServiceClass';

const EmailNotificationSettings: React.FC = () => {
    const [currentNotificationType, setCurrentNotificaitonType] = useState(0);

    const auth = useAuth();
    const loader = useLoader();
    const navigate = useNavigate();

    const handleNotificationChange = (notificationType: number) => {
        const formData = new FormData();

        const upiValue = auth?.upi ? auth?.upi : "";

        formData.append('memberUPI', upiValue);
        formData.append('notificationType', notificationType.toString());

        loader?.setIsLoading(true);
        try {
            ApiService.changeMemberNotificationType(formData)
                .then(() => {
                    loader?.setIsLoading(false);
                    auth?.setNotificationType(notificationType);
                })
                .catch((error) => {
                    console.log(error);
                });
        } catch(error) {
            loader?.setIsLoading(false);
            navigate("/login");
        }
    }

    useEffect(() => {
        const notificationType = auth?.notificationType ? auth?.notificationType : 0;
        setCurrentNotificaitonType(notificationType);
    }, [auth?.notificationType]);
    return (
        <>
            <div className="rounded-sm border border-stroke bg-white py-6 px-7.5 shadow-default dark:border-strokedark dark:bg-boxdark">
                <h5 className="text-xl font-semibold text-black dark:text-white">
                    Email Notification Settings
                </h5>
                <fieldset className="flex max-w-md flex-col gap-4">
                    <legend className="mb-4 mt-4">Choose how you wish to receive notification.</legend>
                    <div className="flex items-center gap-2">
                        <Radio id="default" name="notificationType" value="1" checked={currentNotificationType == 1 ? true : false} onClick={() => handleNotificationChange(1)}/>
                        <Label htmlFor="united-state">Receive notification immediately as soon as status has changed.</Label>
                    </div>
                    <div className="flex items-center gap-2">
                        <Radio id="collate" name="notificationType" value="2"  checked={currentNotificationType == 2 ? true : false} onClick={() => handleNotificationChange(2)}/>
                        <Label htmlFor="germany">Collate notifications and receive only once a day (6 in the afternoon). Does not suppress notifcations from comments.</Label>
                    </div>
                    <div className="flex items-center gap-2">
                        <Radio id="muteall" name="notificationType" value="3" checked={currentNotificationType == 3 ? true : false} onClick={() => handleNotificationChange(3)}/>
                        <Label htmlFor="germany">Mute all notifications including notifications from comments. (Observer Mode)</Label>
                    </div>
                </fieldset>
            </div>
        </>        
    );
};

export default EmailNotificationSettings;